export default "__VITE_ASSET__ChrFNq50__"